import { render, staticRenderFns } from "./form-number.vue?vue&type=template&id=2fdeb9fb&scoped=true"
import script from "./form-number.ts?vue&type=script&lang=ts&external"
export * from "./form-number.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdeb9fb",
  null
  
)

export default component.exports